/**
 * @fileoverview GET handler for the "/engagement/canvas_data(/:workflow_id)" endpoint
 */
import type { CanvasResult } from "@dashboardApi/apis/canvas/common";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { getCanvasStepsPost } from "../canvasSteps";
import { engagementCanvasDataWorkflowId } from "./constants";

export const getCanvas = reactQueryFetcherAdapter(
  engagementCanvasDataWorkflowId,
  async (
    signal: AbortSignal,
    canvasId: string,
    appGroupId: string,
    viewActiveCanvas: boolean
  ): Promise<CanvasResult> => {
    const result = await fetch<CanvasResult>(
      `/engagement/canvas_data/${canvasId}`,
      "GET",
      {
        app_group_id: appGroupId,
        omit_steps: true,
        view_active_canvas: viewActiveCanvas,
      },
      {
        signal,
      }
    );
    if (!result.workflow) {
      throw new Error("Canvas not found");
    }

    result.workflow.steps = await getCanvasStepsPost({
      canvasId,
      appGroupId,
      stepIds: result.workflow.step_ids,
      viewActiveCanvas,
    });

    return result;
  }
);
